import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGetCreatedJobs } from '../../models/jobs/getCreatedJobs.model';

interface ActiveJobCreatedListState {
  page: number;
  perPage: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
  jobData: IGetCreatedJobs[];
}

const initialState: ActiveJobCreatedListState = {
  page: 1,
  perPage: 10,
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
  first: false,
  last: false,
  jobData: [],
};

const activeJobCreatedListSlice = createSlice({
  name: 'activeJobsCreatedList',
  initialState,
  reducers: {
    getActiveJobCreatedList(state, action: PayloadAction<ActiveJobCreatedListState>) {
      // Replace the state with the new pagination data and jobData array.
      return { ...action.payload };
    },
    removeJob(state, action: PayloadAction<string>) {
      state.jobData = state.jobData.filter((job) => job.id !== action.payload);
    },
    addJob(state, action: PayloadAction<IGetCreatedJobs>) {
      state.jobData.unshift(action.payload);
    },
    editJob(state, action: PayloadAction<IGetCreatedJobs>) {
      const index = state.jobData.findIndex(
        (job) => job.id === action.payload.id
      );
      if (index !== -1) {
        state.jobData[index] = action.payload;
      }
    },
  },
});

export const activeJobCreatedListActions = activeJobCreatedListSlice.actions;
export default activeJobCreatedListSlice.reducer;
